import * as THREE from "three";

const north = new THREE.Vector3(0, 0, 1);
const screenRight = new THREE.Vector3();
const screenUp = new THREE.Vector3();

/**
 * Degrees to rotate a north-up compass so N stays aimed at world +Z.
 * In this viewer +Z is geographic north and +X is west.
 * 0° looks north, −90° looks east, 180° looks south, +90° looks west.
 */
export function compassRotationDegrees(camera: THREE.Camera): number {
  camera.updateMatrixWorld();
  screenRight.setFromMatrixColumn(camera.matrixWorld, 0);
  screenUp.setFromMatrixColumn(camera.matrixWorld, 1);
  return THREE.MathUtils.radToDeg(Math.atan2(north.dot(screenRight), north.dot(screenUp)));
}
